import ShoePickerVertical from "./ShoePickerVertical.component";

export default ShoePickerVertical;
